module.exports = __webpack_public_path__ + "static/14-2df1a2b46abaedf8f51e4f1c37552c76.jpg";